import { getChatSession } from './getChatSession'
import { renderMessage } from './renderMessage'
import { scrollChatToBottom } from './scrollChatToBottom'

export function renderChat() {
  const session = getChatSession()
  const chat = /** @type {HTMLTextAreaElement | null} */ (
    document.getElementById('chat')
  )
  if (!chat) {
    throw Error('unexpected: chat area not found')
  }

  // Detect if we're on a /chat page (not /chat-now)
  const pathname = window.location.pathname
  const isChatPage =
    pathname === '/chat' ||
    (pathname.startsWith('/chat/') && !pathname.startsWith('/chat-now'))

  chat.innerHTML = ''
  session.conversation.forEach((message) => {
    // Find the agent for this message to get avatar info
    const agent = session.users.find((u) => u.id === message.authorId)
    const avatar = agent?.avatar || '' // Always show agent avatar if available

    renderMessage(message, {
      avatar,
      showUserAvatar: isChatPage, // Only show user avatars on /chat pages
    })
  })
  scrollChatToBottom()
}
